// NearExpiry.js
import React, { useState, useEffect } from 'react';
import { inventoryAPI } from '../../services/api';
import toast from 'react-hot-toast';

export default function NearExpiry() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [days, setDays] = useState(90);

  useEffect(() => {
    setLoading(true);
    inventoryAPI.nearExpiry({ days })
      .then(r => setItems(r.data))
      .catch(() => toast.error('Failed to load'))
      .finally(() => setLoading(false));
  }, [days]);

  return (
    <div>
      <div className="page-header">
        <div><h1>Near Expiry Products</h1><p className="subtitle">{items.length} batches expiring within {days} days</p></div>
        <div className="page-actions">
          <select className="form-select" style={{width:'auto'}} value={days} onChange={e => setDays(e.target.value)}>
            <option value={30}>30 Days</option><option value={60}>60 Days</option>
            <option value={90}>90 Days</option><option value={180}>180 Days</option>
          </select>
        </div>
      </div>
      <div className="card">
        <div className="table-container">
          {loading ? <div className="loading-container"><div className="spinner" /></div> : (
            <table>
              <thead><tr><th>Product</th><th>SKU</th><th>Batch</th><th>Warehouse</th><th>Expiry Date</th><th>Days Left</th><th style={{textAlign:'right'}}>Qty</th><th>Urgency</th></tr></thead>
              <tbody>
                {items.map(b => (
                  <tr key={b.id}>
                    <td style={{fontWeight:600}}>{b.product_name}</td>
                    <td className="td-mono">{b.sku}</td>
                    <td className="td-mono">{b.batch_number}</td>
                    <td>{b.warehouse_name}</td>
                    <td>{new Date(b.expiry_date).toLocaleDateString('en-IN')}</td>
                    <td style={{fontWeight:700, color: b.days_to_expiry <= 30 ? 'var(--danger)' : b.days_to_expiry <= 60 ? 'var(--accent)' : '#b45309'}}>{b.days_to_expiry} days</td>
                    <td className="td-amount">{b.quantity}</td>
                    <td>{b.days_to_expiry <= 0 ? <span className="badge badge-red">Expired</span> : b.days_to_expiry <= 30 ? <span className="badge badge-red">Critical</span> : b.days_to_expiry <= 60 ? <span className="badge badge-orange">Warning</span> : <span className="badge badge-yellow">Monitor</span>}</td>
                  </tr>
                ))}
                {items.length === 0 && <tr><td colSpan={8} className="text-center text-secondary" style={{padding:40}}>No near-expiry items found</td></tr>}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}
